import * as Yup from "yup";

export const BusinessLabelValidationSchema = Yup.object().shape({
  name: Yup.string().trim().max(50).required("Required!"),
  archetype: Yup.string().nullable(),
});
